import { useMutation } from '@tanstack/react-query';
import { updateGoogleCalendars } from '@/lib/api/integrations';
import type { UpdateCalendarsRequest } from '@/lib/api/integrations/types';
import { stanNotify } from '@/lib/stanNotify';

export const useGoogleCalendarMutation = () => {
    return useMutation({
        mutationFn: (data: UpdateCalendarsRequest) => updateGoogleCalendars(data),
        onSuccess: () => {
            stanNotify({
                type: 'success',
                title: 'Settings Updated',
                text: 'Your calendar settings have been saved successfully.',
            });
        },
        onError: (error: any) => {
            stanNotify({
                type: 'error',
                title: 'Update Failed',
                text: error?.response?.data?.message ?? 'Please try again.',
            });
        },
    });
};
